import { AgentNavbar } from './AgentNavbar';
import { AgentPanel } from './AgentPanel';

export const Agent = () => {
  return (
    <>
      <AgentNavbar />
      <AgentPanel />
    </>
  );
};
